import { SVGProps } from 'react'

type Props = {
  hiddenBg?: boolean
}

export const Search = (props: SVGProps<SVGSVGElement> & Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="37" height="36" fill="none" viewBox="0 0 37 36" {...props}>
    {props.hiddenBg ? (
      <></>
    ) : (
      <rect width="36" height="36" x="0.531" fill="currentColor" fillOpacity="0.08" rx="18"></rect>
    )}
    <path
      fill="currentColor"
      d="M21.845 20.06h-.658l-.234-.226a5.417 5.417 0 001.234-4.45c-.392-2.316-2.325-4.166-4.659-4.45a5.42 5.42 0 00-6.058 6.059c.283 2.333 2.133 4.267 4.45 4.658a5.417 5.417 0 004.45-1.233l.225.233v.659l3.542 3.541a.88.88 0 001.241 0 .88.88 0 000-1.241l-3.533-3.55zm-5 0a3.745 3.745 0 01-3.75-3.75 3.745 3.745 0 013.75-3.75 3.745 3.745 0 013.75 3.75 3.745 3.745 0 01-3.75 3.75z"
    ></path>
  </svg>
)
